import { render, staticRenderFns } from "./KnAuthorizationFilter.vue?vue&type=template&id=5b4f1123"
import script from "./KnAuthorizationFilter.js?vue&type=script&lang=js&external"
export * from "./KnAuthorizationFilter.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports